import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class AlunoEffects {

  constructor(
    private actions$: Actions
  ) {}
}